import MailListItemSelectionSource from "owa-mail-store/lib/store/schema/MailListItemSelectionSource";

export default function focusNextRowBeforeCollapse(nextRowKey: string, mailListItemSelectionSource: MailListItemSelectionSource, expandedRowKey: string, focusedNodeId: string | null): void {
    if (mailListItemSelectionSource !== MailListItemSelectionSource.KeyboardUpDown ||
        nextRowKey === expandedRowKey) {
        return;
    }
    
    focusRowBeforeCollapse(nextRowKey, expandedRowKey, focusedNodeId);
}

export function focusRowBeforeCollapse(rowKey: string, expandedRowKey: string, focusedNodeId: string | null): void {
    const itemPartWrapperElement = document.getElementById(`${expandedRowKey}_itemPartWrapper`);
    const rowElement = document.getElementById(rowKey);
    
    // Move focus off the item part before collapsing it so the browser does not fall back to document.body.
    if (focusedNodeId && itemPartWrapperElement?.contains(document.activeElement) && rowElement) {
        rowElement.focus({ preventScroll: true });
    }
}
